
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"40","height":"40","viewBox":"0 0 40 40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M27.9 15L24 18.9l-3 3c-.2.2-.8.6-1 1l-1-1-2.7-2.7-4.1-4.1c-.9-.9-1.3 2.1-.7 2.7l8.2 8.2c.3.3.4.3.7 0l8.3-8.3c.5-.6.1-3.7-.8-2.7z"}}),_c('path',{attrs:{"d":"M35 19.9c0-.3 0-.5-.1-.7C34.2 11.1 28.7 4 20 4 11.4 4 5 11.5 5 19.9c0 8.3 6.4 15.9 15 15.9 8.7 0 14.2-7.1 14.9-15.1.1-.3.1-.5.1-.8zM20 32.6c-6.5 0-14.1-5.5-13.6-12.7 1.1-16.4 26.4-16.6 27.2 0-.3 7.2-6.5 12.7-13.6 12.7z"}})])
          )
        }
      }
    